import { FeatureFlagUpsertCommandFeatureEnum } from "@/config/apiClient";
import { URL_PATTERN } from "@/constants/regex.constants";
import { z } from "@/helpers/forms/zod";
import { tolgee } from "@/providers/TranslationProvider";

const { Reporting: _reporting, ...BasicFeatureFlagEnum } =
  FeatureFlagUpsertCommandFeatureEnum;

// Define schema for the other feature flags
const basicFeatureFlagSchema = z.object({
  feature: z.nativeEnum(BasicFeatureFlagEnum),
  isActive: z.boolean().default(false),
  metadata: z.record(z.string(), z.string()),
});

// Define schema for the reporting feature flag
const reportingFeatureFlagSchema = z.object({
  feature: z.literal(FeatureFlagUpsertCommandFeatureEnum.Reporting),
  isActive: z.boolean().default(false),
  metadata: z.object({
    url: z.string().optional(),
  }),
});

// Add constraints : url is mandatory only when the reporting flag is enabled
const refinedReportingSchema = reportingFeatureFlagSchema.superRefine(
  (value, ctx) => {
    if (value.isActive) {
      if (!value.metadata.url) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["metadata", "url"],
          message: tolgee.t("inputs.requiredField"),
        });
      } else if (!URL_PATTERN.test(value.metadata.url)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["metadata", "url"],
          message: tolgee.t("oms.featureFlags.REPORTING.metadata.inputError"),
        });
      }
    }
  }
);

// Combine schemas using discriminated union (use refinedReportingSchema here)
const combinedSchema = z.discriminatedUnion("feature", [
  basicFeatureFlagSchema,
  refinedReportingSchema,
]);

// Final schema is an array of feature flags
export const featureFlagSchema = z.object({
  featureFlags: z.array(combinedSchema),
});
export type FeatureFlagFormInputs = z.infer<typeof featureFlagSchema>;
